import { LessonStructure } from 'ingestion/AIGenerated/types'
import { extractSkills } from './extractSkills'

export async function getSkills(
  config: any,
  lesson: LessonStructure,
  name?: string,
): Promise<string[]> {
  const standards = config.includes.reduce(
    (acc: string, includeKey: string) => {
      if (includeKey.split('|').length > 1) {
        const depth = includeKey.split('|')
        const depth1 = lesson.parts.find((part) =>
          name
            ? part.name?.toUpperCase() === name.toUpperCase()
            : part.name?.includes(depth[0].toUpperCase()),
        )
        if (depth1) {
          const depth2 = depth1.parts?.find((part) =>
            part.name?.includes(depth[1].toUpperCase()),
          )
          if (depth2) {
            return [...acc, ...extractSkills(depth2 as any)]
          }
        }
        return acc
      } else {
        const include = lesson.parts.find((part) => {
          return part.name?.includes(includeKey.toUpperCase())
        })
        if (include) {
          return [...acc, ...extractSkills(include as any)]
        }
      }
      return acc
    },
    [],
  )
  if (!standards || standards.length === 0) {
    return []
  }

  return standards
}
